class VariantSplit {
    constructor() {
        this.loaded = false;

        this.SliderNav = $(".productView-nav");
        this.sliderFor = $('.productView-for');
        this.slideColour = $('.product-details.product-left-thumbs').attr('data-product-colour');
        this.hasSlider = false;
    }

    init() {
        if (!this.loaded) {
            // this.buttonDisableOnLoad();
            this.buttonActions();
            this.checkInitialGender();
            this.loaded = true;
            this.checkSlickInitialized();
        }
    }

    checkInitialGender(){
      if(localStorage.getItem("userGender") == "men"){
        this.loopVariants(0);
        $(`.product-form__radio[value="1"]`).removeAttr('checked');
        $(`.product-form__radio[value="0"]`).attr('checked', 'checked');
        $(".custom_variant_head.below_display span.title-midde").text("Men's");
      }else{
        this.loopVariants(1);
        $(`.product-form__radio[value="1"]`).attr('checked', 'checked');
        $(".custom_variant_head.below_display span.title-midde").text("Women's");
      }
    }

    loopVariants(value) {
        let gender = value;
        let variants = window.product_variants;
        variants.forEach(variant => {
            let variantId = variant.id;
            let variantTitle = variant.title.split(/[/|]/);
            let finalText = variantTitle[gender];
            this.changeLabel(variantId, finalText);
        });
    }

    checkSlickInitialized() {

    
      var checkInterval = setInterval(() => {
        if (this.SliderNav.hasClass('swiper-initialized')) {
          clearInterval(checkInterval);
          this.hasSlider = true;
  
          if(localStorage.getItem("userGender") == "men"){
            
            this.menFiltering();
          }else{
            this.womenFiltering();
          }
        } else {
          console.log("Waiting for 'slick-initialized' class...");
        }
      }, 500); // Check every 500ms
    }

    menFiltering(){

      this.SliderNav = $(".productView-nav");
      this.sliderFor = $('.productView-for');

      const navSwiper = slider.getNavSwiper();
      const forSwiper = slider.getForSwiper();

      
      if (this.hasSlider) {
        
        this.SliderNav.find(`.cust-filter-${this.slideColour}-women-image`).remove();
        this.sliderFor.find(`.cust-filter-${this.slideColour}-women-image`).remove();
        navSwiper.destroy();
        forSwiper.destroy();
        slider.init(); 
      }
      
    }
  
    womenFiltering(){

      this.SliderNav = $(".productView-nav");
      this.sliderFor = $('.productView-for');
      
      const navSwiper = slider.getNavSwiper();
      const forSwiper = slider.getForSwiper();
      
      if (this.hasSlider) {
        this.SliderNav.find(`.cust-filter-${this.slideColour}-men-image`).remove();
        this.sliderFor.find(`.cust-filter-${this.slideColour}-men-image`).remove();
        navSwiper.destroy();
        forSwiper.destroy();
        slider.init();
        
      }
    }

    changeLabel(id, finalText) {
        let textArray = finalText.split(/(\d+)/).filter(Boolean);
        let labelCont = $(`.halo-productView-right .product-form__input label[data-variant-id="${id}"]`);
        labelCont.html(`
            <span class="text">
                <span class="text-custom">${textArray[0]}</span>
                <span class="number">${textArray[1]}</span>
            </span>
        `);
    }

    buttonDisableOnLoad() {
        $("#product-add-to-cart").css({ 
            'background-color': '#ccc', 
            'border-color': '#ccc', 
            'pointer-events': 'none'
        }).text("Please select a size");
    }

    buttonActions() {
        $(".input-container").click(() => {
            let current = $(event.currentTarget);
            let currentInput = current.children('input');
            let currentLabel = current.children('label');
            this.loopVariants(currentInput.val());

            if(currentInput.val() == 0){
              fetch(`${window.location.pathname}?section_id=main-product-new-thongs`)
              .then((response) => response.text())
              .then((responseText) => {
                  const html = new DOMParser().parseFromString(responseText, 'text/html');
                  const ImageWrapperContent = html.querySelector('.productView-images-wrapper');
                  const targetImageWrapper = document.querySelector('.productView-images-wrapper');
              
                  if (ImageWrapperContent && targetImageWrapper) {
                  targetImageWrapper.innerHTML = ImageWrapperContent.innerHTML;
                  }
                  this.menFiltering();
              })
              .catch((e) => {
                  console.error(e);
              })
              
              genderUpdateImages('men')
            }else{
              fetch(`${window.location.pathname}?section_id=main-product-new-thongs`)
              .then((response) => response.text())
              .then((responseText) => {
                  const html = new DOMParser().parseFromString(responseText, 'text/html');
                  const ImageWrapperContent = html.querySelector('.productView-images-wrapper');
                  const targetImageWrapper = document.querySelector('.productView-images-wrapper');
              
                  if (ImageWrapperContent && targetImageWrapper) {
                  targetImageWrapper.innerHTML = ImageWrapperContent.innerHTML;
                  }
                  this.womenFiltering();
              })
              genderUpdateImages('women')
            }
          
            $('.input-container input').removeAttr('checked');
            currentInput.attr('checked', 'checked');
            $(".custom_variant_head.below_display span.title-midde").text(currentLabel.text());
            
        });

    }
}

// Instantiate and initialize the class
const variantSplit = new VariantSplit();
variantSplit.init();
